import type { IController, IDocumentService, IScope } from 'angular';
import type { ThemeService } from './mx-theme.service';
import type { EventService } from '../App/services/event-service';
import { EventCodes } from '../App/model/event-codes';

class MxCssVariablesDirectiveCtrl implements IController {
	public static $inject = ['$document', '$scope', 'mx.app.ThemeService', 'mx.shell.EventService'];

	constructor(private readonly $document: IDocumentService, private readonly $scope: IScope, private themeService: ThemeService, private readonly eventService: EventService) {}

	public $onInit() {
		this.eventService.subscribeTo(
			EventCodes.ThemeChanged,
			() => {
				this.applyCssVariables();
			},
			this.$scope
		);
	}

	public async $postLink() {
		this.applyCssVariables();
	}

	private async applyCssVariables() {
		const theme = await this.themeService.getCurrentTheme();
		this.themeService.applyCssVariables(theme, this.$document[0] as Document);
	}
}

export function MxCssVariablesDirective() {
	return {
		restrict: 'A',
		controller: MxCssVariablesDirectiveCtrl,
	};
}
